export default (event, confirmPress, cancelPress) => {
  event.key === 'Enter' && confirmPress();
  event.key === 'Escape' && cancelPress();
};
